import { render, staticRenderFns } from "./HistoricalExportPage.vue?vue&type=template&id=15ba077f&scoped=true&"
import script from "./HistoricalExportPage.vue?vue&type=script&lang=js&"
export * from "./HistoricalExportPage.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalExportPage.vue?vue&type=style&index=0&id=15ba077f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ba077f",
  null
  
)

export default component.exports